module.exports = __webpack_public_path__ + "static/media/favicon.ce8d6c0c.ico";